<template>
  <section-wrapper class="bg-primary-light">
    <section-container mobile-padding class="max-w-container">
      <div class="py-20" style="position:relative">
        <page-header-title invert>Tableau de bord</page-header-title>


<div v-if="company.average_rating !== null" class="rating-stars" style="position:absolute;right:0;margin-top:-40px;" @click="togglePopup">

  <div
    v-for="n in 5"
    :key="n"
    class="star"
    :class="{
        filled: n <= Math.floor(company.average_rating),
        'half-filled': n === Math.ceil(company.average_rating) && company.average_rating % 1 !== 0
      }"
  ></div>
  <span v-if="company.total_reviews > 0" class="review-count">({{ company.total_reviews }})</span>
</div>

<!-- Popup for reviews -->

<div v-if="showPopup" class="popup" @click.self="hidePopup">
  <div class="popup-content">
    <span class="close" @click="hidePopup">&times;</span>
  
    <h1 style="margin-bottom:20px" class="text-primary text-[1.875rem] font-bold leading-[2.5rem]"><span class="bg-secondary mr-3 inline-block h-3 w-3 rounded-full"></span>
Voir les avis
    <span class="bg-ternary ml-3 inline-block h-3 w-3 rounded-full"></span></h1>
    
    <div v-for="(review, index) in company.reviews" :key="review.user_name" class="review">
      <div class="rating-stars">
        <div
          v-for="n in 5"
          :key="n"
          class="star"
          :class="{'filled': n <= review.requester_end_rating}"
        ></div>
      </div>
      <p class="user-name"><strong>{{ review.user_name }}</strong></p>
 
      <div v-if="index < company.reviews.length - 1" class="review-border"></div>
    </div>
  </div>
</div>
        <rounded-button size="sm" icon="refresh" @click="refreshAll"
          >Rafraîchir toutes les données</rounded-button
        >
      </div>

      <div class="flex gap-1 max-md:mb-10 max-md:flex-col">
        <NuxtLink
          v-for="item in menu"
          :key="item.path"
          :to="item.path"
          :class="` rounded-t-2xl max-md:rounded-2xl ${
            $route.path == item.path
              ? ' text-primary bg-white'
              : ' bg-primary-lighter text-white'
          } px-4 py-4 font-medium`"
          ><div>
            <div class="flex" style="font-size:13px">
              <div>
                {{ item.name }}
              </div>
              <div v-if="item.notifications > 0" class="ml-3">
                <Badge :value="item.notifications" severity="danger"></Badge>
              </div>
            </div>
          </div>
        </NuxtLink>
      </div>
    </section-container>
  </section-wrapper>
  <ClientOnly>
    <NuxtPage />
    <verify-mobile-phone-number-modal />
  </ClientOnly>
</template>

<script setup>
import { useAuthStore } from "~/store/auth";
definePageMeta({
  middleware: ["auth"],
});


const showPopup = ref(false);

// Method to toggle the popup
const togglePopup = () => {
  showPopup.value = !showPopup.value;
};

// Method to hide the popup
const hidePopup = () => {
  showPopup.value = false;
};


const authStore = useAuthStore();
const { company } = authStore;

const { $listen, $api, $event, $unListen } = useNuxtApp();

const refreshAll = () => {
  $event("refresh-all");
};

onMounted(() => {
  fetchNotifications();

  $listen("reservation-confirmed", fetchNotifications);
  $listen("reservation-completed", fetchNotifications);
  $listen("refresh-all", fetchNotifications);
});

onBeforeUnmount(() => {
  $unListen("reservation-confirmed", fetchNotifications);
  $unListen("reservation-completed", fetchNotifications);
  $unListen("refresh-all", fetchNotifications);
});

onActivated(() => {
  fetchNotifications();
});

const fetchNotifications = async () => {
  authStore.fetchNotifications();
};

const notificationCounters = computed(() => {
  return authStore.notifications;
});

const myPublishedRoutesNotifications = computed(() => {
  const pending = notificationCounters.value?.pending_incoming_requests ?? 0;
  const incomingWaitingCompletion =
    notificationCounters.value?.incoming_requests_waiting_completion ?? 0;

  return pending + incomingWaitingCompletion;
});

const menu = computed(() => {
  const menu = [
    {
      name: "Mes informations",
      path: "/dashboard",
      notifications: notificationCounters.value?.company ?? 0,
    },
  ];

  if (
    company &&
    company.activated &&
    company.subscribed &&
    company.mobile_verified_at &&
    company.has_stripe_account &&
    company.onboarding_completed &&
    company.has_stripe_customer
  ) {
    menu.push({
      name: "Mes trajets publiés",
      path: "/dashboard/mes-trajets-publies",
      notifications: myPublishedRoutesNotifications.value ?? 0,
    });

    menu.push({
      name: "Mes trajets achetés",
      path: "/dashboard/mes-trajets-achetes",
      notifications:
        notificationCounters.value?.requests_waiting_completion ?? 0,
    });

 menu.push({
      name: "Mes demandes de transport",
      path: "/dashboard/mes-demandes-de-trajets",
      notifications:
        notificationCounters.value?.requests_waiting_completion ?? 0,
    });


    menu.push({
      name: "Mes transports achetés",
      path: "/dashboard/mes-transports-achetes",
     
    });
 

    menu.push({
      name: "Mes alertes",
      path: "/dashboard/mes-alertes",
      notifications: notificationCounters.value?.matched_alerts ?? 0,
    });
  }

  return menu;
});
</script>



<style scoped>
.rating-stars {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.star {
  width: 24px;
  height: 24px;
  background-color: #d3d3d3; /* Light gray for empty star */
  clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
  margin-right: 2px; /* Space between stars */
}

.star.filled {
  background-color: #ffd700; /* Gold for filled star */
}

.star.half-filled {
  background: linear-gradient(to right, #ffd700 50%, #d3d3d3 50%);
}
.review-count {
  margin-left: 8px;
  font-size: 14px;
  color: white; /* Adjust color as needed */
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
    z-index:9999999;
}

.popup-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  position: relative;
  max-width: 90%;
  max-height: 80%;
  overflow-y: auto; /* Scroll if content is too long */
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 18px;
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  position: relative;
  max-width: 90%;
  max-height: 80%;
  overflow-y: auto; /* Scroll if content is too long */
  width: 500px; /* Adjust width as needed */
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 18px;
}

.popup-heading {
  text-align: left;
  margin-bottom: 15px;
  font-size: 20px;
  font-weight: bold;
}

.rating-stars {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.star {
  width: 24px;
  height: 24px;
  background-color: #d3d3d3; /* Light gray for empty star */
  clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
  margin-right: 2px; /* Space between stars */
}

.star.filled {
  background-color: #ffd700; /* Gold for filled star */
}

.user-name {
  margin-top: 5px;
  font-weight: bold;
}

.review-text {
  margin-top: 5px;
}

.review-border {
  border-bottom: 1px solid #ddd;
  margin: 10px 0;
}

.review:last-child .review-border {
  display: none; /* No border for the last review */
}
</style>